document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.crew-popup-wrap').forEach(function (wrap) {
    var uid = wrap.getAttribute('data-crew-uid');
    var btn = document.getElementById('crewBtn-' + uid);
    var closeBtn = document.getElementById('crewClose-' + uid);
    var backdrop = document.getElementById('crewBackdrop-' + uid);
    var modal = document.getElementById('crewModal-' + uid);

    if (!btn || !backdrop || !modal) return;

    function openModal() {
      backdrop.classList.add('open');
      modal.classList.add('open');
      document.body.classList.add('crew-locked');
    }
    function closeModal() {
      backdrop.classList.remove('open');
      modal.classList.remove('open');
      document.body.classList.remove('crew-locked');
    }

    btn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.crew-modal.open').forEach(function (m) {
        m.classList.remove('open');
      });
      document.querySelectorAll('.crew-backdrop.open').forEach(function (b) {
        b.classList.remove('open');
      });
      document.body.classList.remove('crew-locked');
    }
  });
});